function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { DirHelper } from './vaadin-dir-helper.js';
/**
 * Array of Vaadin custom element classes that have been subscribed to the dir changes.
 */

var directionSubscribers = [];

var directionUpdater = function directionUpdater() {
  var documentDir = getDocumentDir();
  directionSubscribers.forEach(function (element) {
    alignDirs(element, documentDir);
  });
};

var scrollType;
var directionObserver = new MutationObserver(directionUpdater);
directionObserver.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['dir']
});

var alignDirs = function alignDirs(element, documentDir) {
  if (documentDir) {
    element.setAttribute('dir', documentDir);
  } else {
    element.removeAttribute('dir');
  }
};

var getDocumentDir = function getDocumentDir() {
  return document.documentElement.getAttribute('dir');
};
/**
 * @polymerMixin
 */


export var DirMixin = function DirMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(VaadinDirMixin, _superClass);

    var _super = _createSuper(VaadinDirMixin);

    function VaadinDirMixin() {
      _classCallCheck(this, VaadinDirMixin);

      return _super.apply(this, arguments);
    }

    _createClass(VaadinDirMixin, [{
      key: "connectedCallback",

      /** @protected */
      value: function connectedCallback() {
        _get(_getPrototypeOf(VaadinDirMixin.prototype), "connectedCallback", this).call(this);

        if (!this.hasAttribute('dir')) {
          this.__subscribe();

          alignDirs(this, getDocumentDir());
        }
      }
      /** @protected */

    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldValue, newValue) {
        _get(_getPrototypeOf(VaadinDirMixin.prototype), "attributeChangedCallback", this).call(this, name, oldValue, newValue);

        if (name !== 'dir') {
          return;
        } // New value equals to the document direction and the element is not subscribed to the changes


        var newValueEqlDocDir = newValue === getDocumentDir() && directionSubscribers.indexOf(this) === -1; // Value was emptied and the element is not subscribed to the changes

        var newValueEmptied = !newValue && oldValue && directionSubscribers.indexOf(this) === -1; // New value is different and the old equals to document direction and the element is not subscribed to the changes

        var newDiffValue = newValue !== getDocumentDir() && oldValue === getDocumentDir();

        if (newValueEqlDocDir || newValueEmptied) {
          this.__subscribe();

          alignDirs(this, getDocumentDir());
        } else if (newDiffValue) {
          this.__subscribe(false);
        }
      }
      /** @protected */

    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(VaadinDirMixin.prototype), "disconnectedCallback", this).call(this);

        this.__subscribe(false);

        this.removeAttribute('dir');
      }
      /** @private */

    }, {
      key: "__subscribe",
      value: function __subscribe() {
        var push = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (push) {
          directionSubscribers.indexOf(this) === -1 && directionSubscribers.push(this);
        } else {
          directionSubscribers.indexOf(this) > -1 && directionSubscribers.splice(directionSubscribers.indexOf(this), 1);
        }
      }
      /**
       * @param {Element} element
       * @return {number}
       * @protected
       */

    }, {
      key: "__getNormalizedScrollLeft",
      value: function __getNormalizedScrollLeft(element) {
        return DirHelper.getNormalizedScrollLeft(scrollType, this.getAttribute('dir') || 'ltr', element);
      }
      /**
       * @param {Element} element
       * @param {number} scrollLeft
       * @protected
       */

    }, {
      key: "__setNormalizedScrollLeft",
      value: function __setNormalizedScrollLeft(element, scrollLeft) {
        return DirHelper.setNormalizedScrollLeft(scrollType, this.getAttribute('dir') || 'ltr', element, scrollLeft);
      }
    }], [{
      key: "finalize",

      /** @protected */
      value: function finalize() {
        _get(_getPrototypeOf(VaadinDirMixin), "finalize", this).call(this);

        if (!scrollType) {
          scrollType = DirHelper.detectScrollType();
        }
      }
    }, {
      key: "properties",
      get: function get() {
        return {
          /**
           * @protected
           */
          dir: {
            type: String,
            readOnly: true
          }
        };
      }
    }]);

    return VaadinDirMixin;
  }(superClass);
};